import emitter from '../../utils/emitter';

export default (($, /* eslint-disable */ window, undefined /* eslint-enable */) => {
  // ready, afterDestroy, afterMinimize, afterMaximize
  const HOOK_FUNCTIONS = ['onButtonStatusChange', 'onHelpButtonClick', 'hideHelpButton', 'showHelpButton'];
  
  class SalesforceLiveAgent {
    constructor() {
      this._initialized = false;
      this._isLiveChatAvailable = null;
      this._svc = null;

      this._waitReady();
    }

    getInstance() {
      return this._svc;
    }
  
    _waitReady() {
      if (typeof window.embedded_svc === 'undefined') {
        window.setTimeout(this._waitReady.bind(this), 200);
      }

      emitter.fire('livechat-ready');
      this._ready();
    }

    _ready() {
      if (this._initialized) {
        return;
      }

      this._initialized = true;

      this._svc = window.embedded_svc;

      this._bindEvents();
      this._hook();
    }

    _hook() {
      if (!this._svc || this._eventsHook) {
        return;
      }

      this._eventsHook = true;

      const svc = this._svc;

      // make sure it has all target functions
      for (let i = 0; i < HOOK_FUNCTIONS.length; i++) {
        if (typeof svc[HOOK_FUNCTIONS[i]] !== 'function') {
          // console.log(`SalesforceLiveAgent init error, ${HOOK_FUNCTIONS[i]} is not a function.`)
          return false;
        }
      }

      // hook into the original function
      for (let i = 0; i < HOOK_FUNCTIONS.length; i++) {
        this._hookLiveChatFunction(svc, HOOK_FUNCTIONS[i]);
      }
    }

    _bindEvents() {
      if (!this._svc || this._eventsBound) {
        return;
      }

      this._eventsBound = true;
    }

    /**
     * Hook into the original function.
     * 
     * @param {Object} svc Salesforce Live Agent instance (window.embedded_svc)
     * @param {String} name Function name
     */
    _hookLiveChatFunction(svc, name) {
      if (typeof svc[name] === 'function' && typeof svc[`__aggreko_hook_org_${name}`] === 'undefined') {
        svc[`__aggreko_hook_org_${name}`] = svc[name];

        svc[name] = (...args) => {
          // call our function
          this._liveChatAvailabilityChanged(svc);

          // call and return with original function result
          //console.log('_hookLiveChatFunction', name, args);
          return svc[`__aggreko_hook_org_${name}`].apply(svc, args);
        };
      }
    }

    /**
     * Custom function that run before the original callback function.
     * 
     * @param {Object} svc Salesforce Live Agent instance (window.embedded_svc)
     */
    _liveChatAvailabilityChanged(svc) {
      var b = (svc && typeof svc.isButtonDisabled !== 'undefined' && svc.isButtonDisabled !== true);
      var c = (svc && typeof svc.componentLoaded !== 'undefined' && svc.componentLoaded !== true);
      c = c && (svc && typeof svc.componentInitInProgress !== 'undefined' && svc.componentInitInProgress !== true);

      // console.log('bbbccc', b, c, svc.componentInitInProgress, svc.componentLoaded);

      //if (this._isLiveChatAvailable !== b) {
      this._isLiveChatAvailable = b;

      // simply emit the event, to be consumed by component JS.
      emitter.fire('livechat-availability-change', {
        available: this._isLiveChatAvailable,
        initInProgress: c
      });
      //}
    }
  }

  let instance = null;

  const init = () => {
    if (!instance) {
      instance = new SalesforceLiveAgent();
    }
    return instance;
  };

  return init;
  
})(jQuery, window);